import { Component, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { IdentityCreditsApiClient } from 'src/app/services/api-clients/identity-credits.api-client';
import { LoggingService } from 'src/app/services/logging.service';
import { ToastService } from 'src/app/services/toast.service';
import { IdentityWhitelabelApiClient } from 'src/app/services/api-clients/identity-whitelabel.api-client';
import { WhiteLabel } from 'src/app/models/whiteLabel';
import { WhiteLabelSettingsApiClient } from 'src/app/services/whitelabel-settings.apiclient';
import { IdsForSettingsService } from '../ids-for-settings.service';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../settings-breadcrumb.service';
import { BaseSettingsCreditsPageClass } from './base-settings-credits-page.class';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';

@Component({
  templateUrl: './settings-credits.page.html'
})
export class SettingsWhiteLabelCreditsPage extends BaseSettingsCreditsPageClass implements OnDestroy {

  selectedWhiteLabelId: string = "";
  whiteLabelIdSubscription: Subscription;
  whitelabel: WhiteLabel = new WhiteLabel;
  wlSettings: any[] = [];
  creditBalanceIsBelowPercentage: boolean = false;
  supportUrl: string = PKIUrls.CreateSupportTicket;
  

  override get NotAllowedToAddOrDeleteCredits(): boolean {
    return !(this.user !== undefined && this.user.isSystemAdmin)
  }

  constructor(
    protected override authenticationService: AuthenticationService,
    protected override loggingService: LoggingService,
    protected override modalService: NgbModal,
    private creditService: IdentityCreditsApiClient,
    private toastService: ToastService,
    private whiteLabelSettingsApiClient: WhiteLabelSettingsApiClient,
    private settingsBreadCrumbService: SettingsBreadCrumbService,
    private identityCreditsApiClient: IdentityCreditsApiClient,
    private identityWhitelabelApiClient: IdentityWhitelabelApiClient,
    private idsForSettingsService: IdsForSettingsService) {

    super(authenticationService, loggingService, modalService);




    this.whiteLabelIdSubscription = this.idsForSettingsService.selectedWhiteLabelId$.subscribe(whiteLabelId => {
      if (!whiteLabelId) return;
      this.selectedWhiteLabelId = whiteLabelId;

      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetWhiteLabelCrumbs(BreadCrumbOptions.Whitelabel_Credits(this.selectedWhiteLabelId));

      // Get the types just incase, so we do not need to await them when opening modal
      this.creditService.getCreditbundleTypesWhiteLabel(this.selectedWhiteLabelId).subscribe(creditBundleTypes =>
        this.creditBundleTypes = creditBundleTypes
      );

      this.identityWhitelabelApiClient.getWhitelabel(whiteLabelId).subscribe(whiteLabelData => {
        this.whitelabel = whiteLabelData;
        // now that we have set the id lets reget credits
        this.getCreditBundles();
      });
      this.identityCreditsApiClient.getReservedCreditForWhiteLabel(this.selectedWhiteLabelId)
        .subscribe((totalReservedCredits: number) => {
          this.totalReservedCredits = totalReservedCredits;
        });
      this.whiteLabelSettingsApiClient.getWhitelabelSettings(this.selectedWhiteLabelId).subscribe({
        next: (data: any) => {
          this.wlSettings = data;
        },
        error: (error: any) => {
          this.loggingService.logException(error);
        }
      });
    });

    this.authenticationService.currentUser.subscribe({
      next: (data: any) => {
        this.user = data;
      },
      error: (error: any) => {
        this.loggingService.logException(error);
      }
    });
  }
  ngOnDestroy(): void {
    this.whiteLabelIdSubscription.unsubscribe();
  }


  protected override async getCreditBundles() {
    (await this.creditService.getCreditbundlesWhiteLabel(this.whitelabel.whiteLabel.guid)).subscribe({
      next: (data: any) => {
        this.credits = [];
        this.credits = data;
      }
    });
  }

  override filterSettings(keys: string[]) {
    let returnObject: { [k: string]: any } = {};
    keys.forEach((k: string) => {
      if (this.wlSettings.findIndex(os => os.key == k) > -1) { returnObject[k] = this.wlSettings[this.wlSettings.findIndex(os => os.key == k)].value }
    })
    return returnObject;
  }

  override updateSettings(settings: any) {
    settings.forEach((setting: any) => {
      let settingIndex = this.wlSettings.findIndex(s => s.key === setting.key);
      if (settingIndex > -1) this.wlSettings[settingIndex].value = setting.value;
      else this.wlSettings.push(setting);
    });
    this.whiteLabelSettingsApiClient.postOrganisationSettings(this.selectedWhiteLabelId, settings).subscribe({
      next: () => {
        this.toastService.showSaved();
      },
      error: () => {
      }
    });
  }

  override async deleteCreditBundle(event: any) {
    (await this.creditService.deleteCreditbundleWhiteLabel(this.selectedWhiteLabelId, event)).subscribe({
      next: () => {
        this.toastService.showSaved();
        this.getCreditBundles();
      }
    });
  }

  override async postCredits(credits: any) {
    (await this.creditService.postCreditBundleWhiteLabel(this.selectedWhiteLabelId, credits)).subscribe({
      next: () => {
        this.toastService.showSaved();
        this.modalRef.close();
        this.getCreditBundles();
      },
      error: () => {
        this.toastService.showErrorByKey('Toasts.ErrorAddingCreditBundle');
      }
    });
  }

}

